import createReactComponent from '../createReactComponent';
export default createReactComponent('outline', 'caret-right', 'IconCaretRight', [["path",{"d":"M10 18l6 -6l-6 -6v12","key":"svg-0"}]]);